import { render, staticRenderFns } from "./FeatureConfigContainer.vue?vue&type=template&id=283f4216&"
import script from "./FeatureConfigContainer.vue?vue&type=script&lang=js&"
export * from "./FeatureConfigContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports